module.exports = __webpack_public_path__ + "img/luca.94c79f18.jpg";